import { useEffect } from "react";
import { axiosPrivate } from "../config/Api";
import { removeLoggedInUser } from "service/AuthService";
// import { useAuth } from "./useAuth";
// import { useRefreshToken } from "./useRefreshToken";

export const useAxiosPrivate = () => {
  // const refresh = useRefreshToken();
  // const { auth } = useAuth();
  // console.log(auth.token)
  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          // config.headers["Authorization"] = `Bearer ${auth.token}`;
          config.headers["Authorization"] = `Bearer ${localStorage
            .getItem("token")
            .replace(/^"(.*)"$/, "$1")}`;
        }
        // console.log(config)
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error.config;
        if (error.response.status === 401 && !prevRequest.sent) {
          prevRequest.sent = true;
          // const newAccessToken = await refresh();
          // prevRequest.headers["Authorization"] = `${newAccessToken}`;
          // return axiosPrivate(prevRequest);
          removeLoggedInUser();
          window.location.href = "/authentication/sign-in";
          return;
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, []);

  return axiosPrivate;
};
